<template>
  <nav class="sc-tabs mb-3">
    <li
      v-for="(tab, index) in tabs"
      v-show="tab.isShow"
      :key="index"
      :class="{ active: currentTab.name === tab.name }"
      class="sc-tab"
      @click="changeTab(tab)"
    >
      {{ tab.name }}
    </li>
  </nav>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tabs: [
        { name: "เนื้อหา", isShow: true },
        { name: "รายละเอียดกิจกรรม", isShow: true }
      ],
    };
  },
  computed: {
    currentTab() {
      return this.value || this.tabs[0];
    },
  },
  methods: {
    changeTab(to) {
      this.$emit("input", to);
    }
  }
};
</script>

<style scoped></style>
